import { render, staticRenderFns } from "./TrainerSidebar.vue?vue&type=template&id=93eda2f2&scoped=true"
import script from "./TrainerSidebar.vue?vue&type=script&lang=js"
export * from "./TrainerSidebar.vue?vue&type=script&lang=js"
import style0 from "./TrainerSidebar.vue?vue&type=style&index=0&id=93eda2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eda2f2",
  null
  
)

export default component.exports